import * as React from 'react';

function RateManual(props) {
  return (
    <svg width={40} height={56} fill="none" {...props}>
      <rect
        width={40}
        height={56}
        rx={4}
        fill="url(#prefix__paint0_linear_984_12565)"
      />
      <path
        d="M11.84 25.512l-.804 1.404c-.48-.324-.996-.576-1.488-.708v1.824c1.824.492 2.604 1.224 2.604 2.568v.024c0 1.344-1.044 2.208-2.544 2.364v1.188H8.36v-1.212a5.907 5.907 0 01-2.832-1.14l.936-1.368c.66.492 1.236.828 1.956.972V29.52c-1.728-.48-2.58-1.104-2.58-2.544v-.024c0-1.32 1.008-2.196 2.52-2.352v-.696h1.248v.732c.864.108 1.56.408 2.232.876zM10.4 30.72v-.024c0-.396-.192-.648-.852-.888v1.68c.564-.084.852-.348.852-.768zm-2.808-3.876v.024c0 .384.168.624.828.864V26.1c-.588.084-.828.36-.828.744z"
        fill="#3E0C9D"
      />
      <path
        opacity={0.5}
        d="M18 26h15M18 32h15"
        stroke="#B89EFF"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <path
        d="M11.84 8.512l-.804 1.404c-.48-.324-.996-.576-1.488-.708v1.824c1.824.492 2.604 1.224 2.604 2.568v.024c0 1.344-1.044 2.208-2.544 2.364v1.188H8.36v-1.212a5.907 5.907 0 01-2.832-1.14l.936-1.368c.66.492 1.236.828 1.956.972V12.52c-1.728-.48-2.58-1.104-2.58-2.544v-.024c0-1.32 1.008-2.196 2.52-2.352v-.696h1.248v.732c.864.108 1.56.408 2.232.876zM10.4 13.72v-.024c0-.396-.192-.648-.852-.888v1.68c.564-.084.852-.348.852-.768zM7.592 9.844v.024c0 .384.168.624.828.864V9.1c-.588.084-.828.36-.828.744z"
        fill="#3E0C9D"
      />
      <path
        opacity={0.5}
        d="M18 9h15M18 15h15"
        stroke="#B89EFF"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <path
        d="M11.84 41.512l-.804 1.404c-.48-.324-.996-.576-1.488-.708v1.824c1.824.492 2.604 1.224 2.604 2.568v.024c0 1.344-1.044 2.208-2.544 2.364v1.188H8.36v-1.212a5.907 5.907 0 01-2.832-1.14l.936-1.368c.66.492 1.236.828 1.956.972V45.52c-1.728-.48-2.58-1.104-2.58-2.544v-.024c0-1.32 1.008-2.196 2.52-2.352v-.696h1.248v.732c.864.108 1.56.408 2.232.876zM10.4 46.72v-.024c0-.396-.192-.648-.852-.888v1.68c.564-.084.852-.348.852-.768zm-2.808-3.876v.024c0 .384.168.624.828.864V42.1c-.588.084-.828.36-.828.744z"
        fill="#3E0C9D"
      />
      <path
        opacity={0.5}
        d="M18 42h15M18 48h15"
        stroke="#B89EFF"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_984_12565"
          x1={20}
          y1={0}
          x2={20}
          y2={56}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F0FF" />
          <stop offset={1} stopColor="#E4DEFC" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const MemoRateManual = React.memo(RateManual);
export default MemoRateManual;
